import React from 'react';

function DocumentItem({filename, setFileName, documentBody, setDocumentBody}) {
    return(
        <>
            {documentBody && (
                <div className="p-2 relative w-fit">
                    <div className="h-10rem border-round-xl p-2 border-1 border-gray-400 bg-gray-300">
                        <img alt={filename} className="h-full border-round border-1 border-primary" src={`data:image/jpeg;base64,${documentBody}`}/>
                    </div>
                    <span className="pi pi-times bg-primary p-2 border-circle cursor-pointer absolute left-0 top-0" onClick={()=>{setDocumentBody(undefined); setFileName(undefined)}}/>
                </div>
            )}
        </>
    )
}

export default DocumentItem;